'use client';

import _defineProperty from "/codebuild/output/src2858/src/s3/01/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/codebuild/output/src2858/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/codebuild/output/src2858/src/s3/01/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["sizes", "onSizesChange", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx } from 'react/jsx-runtime';
import { forwardRef, useState, useRef, useEffect } from 'react';
import { useMergedRef } from '@mantine/hooks';
import { useScrollAreaContext } from '../ScrollArea.context.mjs';
import { isScrollingWithinScrollbarBounds } from '../utils/is-scrolling-within-scrollbar-bounds.mjs';
import { getThumbSize } from '../utils/get-thumb-size.mjs';
import { toInt } from '../utils/to-int.mjs';
import { Scrollbar } from './Scrollbar.mjs';
var ScrollAreaScrollbarX = forwardRef(function (props, forwardedRef) {
  var sizes = props.sizes,
    onSizesChange = props.onSizesChange,
    style = props.style,
    others = _objectWithoutProperties(props, _excluded);
  var ctx = useScrollAreaContext();
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    computedStyle = _useState2[0],
    setComputedStyle = _useState2[1];
  var ref = useRef(null);
  var composeRefs = useMergedRef(forwardedRef, ref, ctx.onScrollbarXChange);
  useEffect(function () {
    if (ref.current) setComputedStyle(getComputedStyle(ref.current));
  }, [ref]);
  return /* @__PURE__ */jsx(Scrollbar, _objectSpread(_objectSpread({
    "data-orientation": "horizontal"
  }, others), {}, {
    ref: composeRefs,
    sizes: sizes,
    style: _objectSpread(_objectSpread({}, style), {}, _defineProperty({}, "--sa-thumb-width", "".concat(getThumbSize(sizes), "px"))),
    onThumbPointerDown: function onThumbPointerDown(pointerPos) {
      return props.onThumbPointerDown(pointerPos.x);
    },
    onDragScroll: function onDragScroll(pointerPos) {
      return props.onDragScroll(pointerPos.x);
    },
    onWheelScroll: function onWheelScroll(event, maxScrollPos) {
      if (ctx.viewport) {
        var scrollPos = ctx.viewport.scrollLeft + event.deltaX;
        props.onWheelScroll(scrollPos);
        if (isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) {
          event.preventDefault();
        }
      }
    },
    onResize: function onResize() {
      if (ref.current && ctx.viewport && computedStyle) {
        onSizesChange({
          content: ctx.viewport.scrollWidth,
          viewport: ctx.viewport.offsetWidth,
          scrollbar: {
            size: ref.current.clientWidth,
            paddingStart: toInt(computedStyle.paddingLeft),
            paddingEnd: toInt(computedStyle.paddingRight)
          }
        });
      }
    }
  }));
});
export { ScrollAreaScrollbarX };